import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

function ClientViewer() {
  const [projectNumber, setProjectNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!projectNumber.trim()) {
      setError('Please enter a project number');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`/api/projects/${projectNumber.trim()}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          setError('Project not found. Please check your project number.');
        } else {
          setError('Error fetching project. Please try again.');
        }
        setLoading(false);
        return;
      }

      navigate(`/project/${projectNumber.trim()}`);
    } catch (err) {
      setError('Network error. Please check your connection.');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Client Project Viewer
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Enter your project number to view details, quotes, and 3D models
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              label="Project Number"
              variant="outlined"
              value={projectNumber}
              onChange={(e) => setProjectNumber(e.target.value)}
              placeholder="e.g., WW-2024-001"
              sx={{ mb: 3 }}
              disabled={loading}
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              fullWidth
              startIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
              disabled={loading}
            >
              {loading ? 'Searching...' : 'View Project'}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default ClientViewer;
